import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import CustomButton from "../controls/CustomButton";
import "./../../assets/css/PatientModal.css";
import {
  addAgencyPharmacy,
  sendToOrbit,
  setCurrentPharmacyServices,
  setInterventionStageScrollPosition,
  setScrollPosition,
  getAgencyPharmacy,
  setOrbitSend,
  sendToAgencyOrbit,
} from "../../dispatchers/pharmacyServiceDispatchers";
import { cancelPharmacyNmsRequest } from "../../dispatchers/orbitDispatchers";
import useTitanApp from "../../hooks/useTitanApp";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { showError } from "../ToastedMessage/ToastedMessage";
import { Box, IconButton } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import TitanOrbitWithGlobeLightSVG from "../../assets/images/Titan_Orbit_With_Globe_Light.svg";
import TitanOrbitWithGlobeDarkSVG from "../../assets/images/Titan_Orbit_With_Globe_Dark.svg";
import { Close } from "@mui/icons-material";
import * as Yup from "yup";
import StartOrbitSendModal from "./StartOrbitSendModal";
import CancelOrbitSendModal from "./CancelOrbitSendModal";
import AnyPartnerOrbitSendModal from "./AnyPartnerModal";
import ExclusivePartnerOrbitSendModal from "./ExclusivePartnerModal";
import PartnerTypeOptions from "./PartnerTypeOptions";
import CustomLoader from "../controls/CustomLoader";
import LottieLoader from "../controls/LottieLoader";

const validationSchema = Yup.object().shape({
  reason: Yup.string()
    .required("Please enter a reason.")
    .test(
      "not-empty",
      "Reason cannot be just spaces.",
      (value) => value?.trim().length > 0
    ),
  note: Yup.string().nullable(),
});

export default function OrbitSendModal({
  checksCount,
  view,
  rowData,
  setRowData,
}) {
  const { appState, pharmacyServiceState } = useTitanApp();
  const { darkMode, currentPharmacyId } = appState || {};
  const {
    agencyRates,
    pharmacyServices,
    orbitModalQueue,
    agencyPharmacy,
    isAgencyRatesLoading,
  } = pharmacyServiceState || {};
  const { pharmacyID } = agencyPharmacy;
  const [show, setShow] = useState(true);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [selectedPartnerType, setSelectedPartnerType] =
    useState("Exclusive Partner");
  const [selectedPriceIndex, setSelectedPriceIndex] = useState(1);
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState("");
  const [note, setNote] = useState("");

  useEffect(() => {
    if (
      agencyPharmacy.exclusivePartnerCompanyID !== null &&
      agencyRates !== null
    ) {
      const exclusivePartner = agencyRates.find((pharmacy) => {
        return pharmacy.companyID === agencyPharmacy.exclusivePartnerCompanyID;
      });
      setSelectedPartner(exclusivePartner);
    }
  }, [agencyPharmacy]);
  // const [step, setStep] = useState(() => {
  //   return agencyPharmacy?.exclusivePartnerCompanyID ? 2 : 1;
  // });
  const [step, setStep] = useState(2);
  const handleContinue = () => {
    if (step === 1) {
      setStep(2);
    }
  };
  const handleCancel = () => {
    setStep(3);
  };
  const handleGoBack = () => {
    setStep(2);
  };
  const handleClose = (event) => {
    setShow(false);
    setOrbitSend(false);
  };
  const handleSelectPartner = (partner) => {
    setSelectedPartner(partner);
  };
  const handleDeleteRequest = async () => {
    try {
      await validationSchema.validate({ reason });
      setReasonError("");
      if (selectedPartner) {
        const { companyID } = selectedPartner;

        try {
          const data = await cancelPharmacyNmsRequest({
            pharmacyID,
            companyID,
            cancelReason: reason,
            nmsConsentedResponseRate: agencyPharmacy?.nmsConsentedResponseRate,
            nmsUnconsentedResponseRate:
              agencyPharmacy?.nmsUnconsentedResponseRate,
          });
          if (data === true) {
            await getAgencyPharmacy(currentPharmacyId);
            showToast(
              `Exclusive partnership with ${selectedPartner?.companyName} cancelled successfully!`
            );
            handleClose();
          }
        } catch (error) {
          console.error("Error removing selected partner:", error);
          showToast(
            "Something went wrong while removing the partnership.",
            "error"
          );
        }
      }
    } catch (error) {
      setReasonError(error.message);
    }
  };
  const handleTogglePartnerType = (title) => {
    setSelectedPartnerType(title);
  };
  const showToast = (message) => {
    toast.success(`${message}`, {
      className: "services-toast",
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 3000,
      theme: darkMode ? "dark" : "light",
    });
  };

  const handleSubmit = async () => {
    let updatedData;
    let sendModal;

    if (selectedPartnerType !== "Any Partner" && selectedPartner !== null) {
      const obj = {
        companyID: selectedPartner?.companyID,
        pharmacyID: currentPharmacyId,
        isActive: true,
        workLoadType: 1,
        unConsentedRate: selectedPartner?.unConsentedRate,
        consentedRate: selectedPartner?.consentedRate,
        nmsCount: 0,
      };

      updatedData = orbitModalQueue?.map((item) => ({
        ...item,
        rate:
          selectedPriceIndex === 1
            ? selectedPartner?.unConsentedRate
            : selectedPartner?.consentedRate,
        companyID: selectedPartner?.companyID,
      }));

      sendModal = {
        orbitQueue: updatedData,
        exclusivePartnerCompanyID: selectedPartner?.companyID,
        note: note,
      };

      if (agencyPharmacy?.CompanyID !== selectedPartner?.companyID) {
        const data = await addAgencyPharmacy(obj);
        if (data) {
          await callSendToOrbit(sendModal);
          await getAgencyPharmacy(currentPharmacyId);
        }
      } else {
        await callSendToOrbit(sendModal);
      }
    } else {
      updatedData = orbitModalQueue?.map((item) => ({
        ...item,
        rate: selectedPriceIndex === 1 ? "8" : "5",
        isAutoConsent: selectedPriceIndex === 1,
        companyID: null,
      }));

      sendModal = {
        orbitQueue: updatedData,
        exclusivePartnerCompanyID: null,
        note: note,
      };

      await callSendToOrbit(sendModal);
    }
  };
  const callSendToOrbit = async (updatedData) => {
    handleClose();
    var data = await sendToAgencyOrbit(updatedData);
    if (data != null) {
      try {
        if (view === "kanban") {
          const newData = pharmacyServices?.map((stage) => ({
            ...stage,
            sortedServices: stage?.sortedServices?.map((service) => ({
              ...service,
              clinicalServices: [...service?.clinicalServices],
            })),
          }));
          const updatedNewData = newData?.map((stage) => {
            if (stage.stageType === 3) {
              return {
                ...stage,
                sortedServices: stage?.sortedServices?.map((serviceGroup) => ({
                  ...serviceGroup,
                  clinicalServices: serviceGroup?.clinicalServices?.map(
                    (clinicalService) => {
                      const queueItem = orbitModalQueue?.find(
                        (item) =>
                          item?.clinicalServiceID === clinicalService?._id
                      );
                      if (queueItem) {
                        return {
                          ...clinicalService,
                          sendToOrbit: true,
                        };
                      }
                      return clinicalService;
                    }
                  ),
                })),
              };
            }
            return stage;
          });
          setCurrentPharmacyServices(updatedNewData);
          const stagesWrapperOrbit = document.querySelector(".stages-wrapper");
          if (stagesWrapperOrbit) {
            setScrollPosition(stagesWrapperOrbit.scrollLeft);
          }
          const stageIntervention =
            document.getElementById("stage_Intervention");
          if (stageIntervention) {
            setInterventionStageScrollPosition(stageIntervention?.scrollTop);
          }
        } else {
          let mutableData = JSON.parse(JSON.stringify(rowData));
          orbitModalQueue?.forEach((queueItem) => {
            mutableData?.forEach((patient) => {
              if (patient) {
                if (
                  patient?.clinicalServiceId === queueItem?.clinicalServiceID &&
                  patient?.stageType === 3
                ) {
                  patient.sendToOrbit = "Yes";
                }
              }
            });
          });
          const stageOrder = {
            Eligible: 1,
            "Awaiting consent": 2,
            Intervention: 3,
            Followup: 4,
          };
          mutableData?.sort((a, b) => {
            return stageOrder[a?.stageName] - stageOrder[b?.stageName];
          });
          setRowData(mutableData);
        }
        if (data === true) {
          showToast(
            `Record ${
              orbitModalQueue?.length > 1 ? "s" : ""
            } moved to Orbit successfully!`
          );
        }
      } catch (error) {
        showError("Something went wrong");
      }
    }
  };
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        centered
        className="max-z"
      >
        <div className="clinical_modal send_to_orbit_modal_wrapper">
          <Modal.Body>
            {isAgencyRatesLoading ? (
              <div className="pharmacy-loader">
                <LottieLoader />
              </div>
            ) : (
              <Box className="modal-s-orbit">
                <div className="nms-to-orbit-header">
                  <div className="send-to-orbit-modal-logo">
                    {darkMode ? (
                      <TitanOrbitWithGlobeDarkSVG />
                    ) : (
                      <TitanOrbitWithGlobeLightSVG />
                    )}
                  </div>
                  <div className="send-to-orbit-modal-close">
                    <IconButton onClick={handleClose}>
                      <Close />
                    </IconButton>
                  </div>
                </div>
                {(() => {
                  switch (step) {
                    case 1:
                      return (
                        <StartOrbitSendModal handleContinue={handleContinue} />
                      );
                    case 2:
                      return (
                        <>
                          {/* {agencyPharmacy?.exclusivePartnerCompanyID === null && (
                              <PartnerTypeOptions 
                                handleTogglePartnerType={handleTogglePartnerType} 
                                selectedPartnerType={selectedPartnerType}/>
                            )} */}
                          {selectedPartnerType === "Any Partner" ? (
                            <AnyPartnerOrbitSendModal />
                          ) : (
                            <ExclusivePartnerOrbitSendModal
                              agencyPharmacy={agencyPharmacy}
                              selectedPartner={selectedPartner}
                              handleCancel={handleCancel}
                              handleSelectPartner={handleSelectPartner}
                              agencyRates={agencyRates}
                              note={note}
                              setNote={setNote}
                            />
                          )}
                          {(selectedPartnerType === "Any Partner" ||
                            (selectedPartnerType === "Exclusive Partner" &&
                              selectedPartner)) && (
                            <div className="send-to-orbit-footer">
                              <CustomButton
                                label="Send"
                                icon={<NavigateNextIcon color="white" />}
                                action={handleSubmit}
                              />
                            </div>
                          )}
                        </>
                      );
                    case 3:
                      return (
                        <CancelOrbitSendModal
                          handleGoBack={handleGoBack}
                          selectedPartnerType={selectedPartnerType}
                          selectedPartner={selectedPartner}
                          handleDeleteRequest={handleDeleteRequest}
                          reasonError={reasonError}
                          setReason={setReason}
                          reason={reason}
                        />
                      );
                    default:
                      return <>default</>;
                  }
                })()}
              </Box>
            )}
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
}

